import pokemonApi from "../api/pokemonApi"

const getPokemon = () => {

    // CREA UN ARRAY PERSONALIZADO
    const pokemonArr = Array.from(Array(650))
    
    // MAPEA LA CANTIDAD DE ARRARY PERSONALIZADO Y LE SUMA UNO AL INDICE
    return pokemonArr.map((_, index) => index + 1)

}

const getPokemonOptions = async() => {

    // HACE UN CALCULO RANDON DE 1 HASTA 650
    const mixedPokemon = getPokemon().sort(() => Math.random() - 0.5)

    // LLAMA A LOOS CUATRO POKEMONES QUE SE PRESENTARAN EN LA APP
    const pokemons = await getPokemonNames(mixedPokemon.slice(0, 4))

    return pokemons
}


const getPokemonNames = async ([a, b, c, d] = []) => {

    // const resp = await pokemonApi.get(`/1`)
    // console.log(resp);

    const promiseArr = [
        pokemonApi.get(`/${a}`),
        pokemonApi.get(`/${b}`),
        pokemonApi.get(`/${c}`),
        pokemonApi.get(`/${d}`)
    ]

    const [p1 ,p2 ,p3 ,p4] = await Promise.all(promiseArr)
    
    return [
        {name: p1.data.name, id: p1.data.id},
        {name: p2.data.name, id: p2.data.id},
        {name: p3.data.name, id: p3.data.id},
        {name: p4.data.name, id: p4.data.id},
    ]

}

export default getPokemonOptions;